import React, { useEffect, useRef, useState } from "react";
import { useInView, useMotionValue, animate } from "framer-motion";

export default function CountUp({ value = 0, duration = 2, suffix = "", className = "", prefix = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const mv = useMotionValue(0);
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    if (inView) {
      const target = Number(value) || 0;
      const controls = animate(mv, target, { duration, ease: [0.16, 1, 0.3, 1], onUpdate: v => setDisplay(Math.round(v)) });
      return () => controls.stop();
    }
  }, [inView, value, duration, mv]);
  return <span ref={ref} className={className}>{prefix}{display.toLocaleString("fr-FR")}{suffix}</span>;
}
